import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { Transcript } from '../transcript';
import { JobWithAttachments } from './JobWithAttachments';
/**
 * A transcription job along with its attachments and transcript file details, and other relevant fields from the Order.
 */
export class JobWithTranscriptResponse extends JobWithAttachments {
}
__decorate([
    Type(() => Transcript),
    __metadata("design:type", Object)
], JobWithTranscriptResponse.prototype, "transcript", void 0);
